export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "网红大瓜一般多久更新一次？",
    answer:
      "常规情况下每天更新 3 条以上，遇到讨论度高的突发事件会随时加更。年度大瓜与超级大瓜这类盘点型内容按季度整理，方便你集中补看。",
  },
  {
    question: "这里的爆料内容都是从哪来的？",
    answer:
      "全部来自公开渠道：创作者本人的账号动态、平台公开的原帖、当事人发布的说明，以及被广泛引用且可追溯来源的截图。我们不使用无法核实来源的私人材料。",
  },
  {
    question: "为什么有些内容会标注「待核实」？",
    answer:
      "当一条信息只有单方说法、缺少原始材料或存在明显矛盾时，我们会标注「待核实」。这不是回避，而是提醒你先别急着下结论，等后续进展更完整再看。",
  },
  {
    question: "被整理到的当事人可以要求修改或删除吗？",
    answer:
      "可以。如果内容存在事实性错误，或涉及你不希望公开的个人信息，欢迎通过联系页面提交说明，我们会尽快核对并修正或下架相关内容。",
  },
  {
    question: "我可以自己投稿爆料吗？",
    answer:
      "当然可以。在联系我们页面有投稿入口，尽量附上原始链接、截图和时间，材料越完整，被整理成时间线的可能性越高，也越能减少误伤。",
  },
  {
    question: "站点会给出结论或立场吗？",
    answer:
      "大多数时候不会。我们的工作是整理材料、排好顺序、补齐双方说法，把判断留给你。只有在事实层面能明确证伪的内容上，我们才会直接标注出来。",
  },
];